import { Tooltip } from 'antd'
import { Icon } from '@iconify/react'

// styles
import styles from './header.module.css'

const HeaderLeftSection = ({ props }) => {
    const { collapsed, setCollapsed } = props || {}

    return (
        <>
            <div className={styles.leftSection}>
                {collapsed !== undefined && setCollapsed && (
                    <Tooltip
                        title={collapsed ? 'Expand sidebar' : 'Hide sidebar'}
                        arrow={false}
                        placement="bottom"
                    >
                        <Icon
                            icon={'solar:hamburger-menu-linear'}
                            width={22}
                            height={22}
                            onClick={() => setCollapsed(!collapsed)}
                            className={styles.sidebarToggleButton}
                        />
                    </Tooltip>
                )}
            </div>
        </>
    )
}

export default HeaderLeftSection
